import { gql } from '@apollo/client';

export type GetAdminByEmailResponse = {
  adminUserByEmail: {
    id: string;
    roles: string[];
  };
};

export const GET_ADMIN_BY_EMAIL = gql`
  query adminUserByEmail($email: String!) {
    adminUserByEmail(email: $email) {
      id
      roles
      email
    }
  }
`;
